var _rect, _path, _rect2, _rect3, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 29,
    viewBox: "0 0 38 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 29,
    rx: 6,
    fill: "#176318"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H32C35.3137 0 38 2.68629 38 6H0Z",
    fill: "#CBDCCB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.59375,
    y: 23.5117,
    width: 11.7257,
    height: 2,
    rx: 1,
    transform: "rotate(-50.85 5.59375 23.5117)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8047,
    y: 23.5996,
    width: 18.6027,
    height: 2,
    rx: 1,
    transform: "rotate(-46.9449 17.8047 23.5996)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0234,
    y: 24.9219,
    width: 11.7826,
    height: 2,
    rx: 1,
    transform: "rotate(-127.532 19.0234 24.9219)",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7436 9.03019L32.1358 13.5558L28.2903 10.0394L32.7436 9.03019Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryDash);
export default __webpack_public_path__ + "static/media/HistoryDash.81b3a4d9054ebaf0c52321a1a96a8bd1.svg";
export { ForwardRef as ReactComponent };